//Category 1: Finance Questions 2
//Category 2: Generic Questions 2
//Category 3: Health and well being Questions 1
//Category 4: Joyful Expressions Questions 2
//Category 5: Mandatory 1
//Category 6: Social Connection 1

export const questions = [
  {
    id: 1,
    category: 1,
    que: "In the last 4 months, for how many times, you felt that you are paid less?",
    queHindi:"पिछले 4 महीनों में, कितनी बार आपको लगा कि आपको कम पैसे मिल रहे हैं?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2-3 times",
    optcHindi: "2-3 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
    // This question will be scored in reverse, meaning lower scores are better
  },
  {
    id: 2,
    category: 1,
    que: "In the last 4 months, for how many times, you felt that you had taken too big loan amount?",
    queHindi: "पिछले 4 महीनों में, कितनी बार आपको लगा कि आपने बहुत बड़ा लोन ले लिया है?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1-2 times",
    optbHindi: "1-2 बार",
    optc: "3-4 times",
    optcHindi: "3-4 बार",
    optd: "4+ times",
    optdHindi: "4+ बार",
    reverseScoring: true, // reverse scoring for this question
  },
  {
    id: 3,
    category: 1,
    que: "What is the total value of loans you have?",
    queHindi:
      "आपके पास कितने का लोन है?",
    opta: "0 lakh",
    optaHindi: "0 लाख",
    optb: "1–5 lakh",
    optbHindi: "1–5 लाख",
    optc: "6–20 lakh",
    optcHindi: "6–20 लाख",
    optd: "20+ lakh",
    optdHindi: "20+ लाख",
    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 4,
    category: 1,
    que: "How many people are financially dependent on you?",
    queHindi:
      "आप पर आर्थिक रूप से कितने लोग निर्भर हैं?",
    opta: "0",
    optaHindi: "0",
    optb: "1-2",
    optbHindi: "1-2",
    optc: "3-4",
    optcHindi: "3-4",
    optd: "4+",
    optdHindi: "4+",
    reverseScoring: true, // Normal scoring for this question
  },
  {
    id: 5,
    category: 1,
    que: "In the last 6 months, how many people have you helped financially?",
    queHindi:
      "पिछले 6 महीनों में, आपने कितने लोगों की आर्थिक मदद की?",
    opta: "0",
    optaHindi: "0",
    optb: "1",
    optbHindi: "1",
    optc: "2-5",
    optcHindi: "2-5",
    optd: "5+",
    optdHindi: "5+",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 6,
    category: 1,
    que: "What percentage of your income goes into loan repayment?",
    queHindi: "आपकी आय का कितना प्रतिशत हिस्सा लोन में जाता है?",
    opta: "0-10%",
    optaHindi: "0-10%",
    optb: "10-40%",
    optbHindi: "10-40%",
    optc: "40-70%",
    optcHindi: "40-70%",
    optd: "70%+",
    optdHindi: "70%+",
    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 7,
    category: 1,
    que: "What percentage of your income is spent on healthcare?",
    queHindi:
      "आपकी आय का कितना प्रतिशत हिस्सा स्वास्थ्य पर खर्च होता है?",
    opta: "0%",
    optaHindi: "0%",
    optb: "5%",
    optbHindi: "5%",
    optc: "10%",
    optcHindi: "10%",
    optd: "20%+",
    optdHindi: "20%+",
    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 8,
    category: 1,
    que: "How many loans do you have in total (home, car, personal, education, etc.)?",
    queHindi:
      "आपके पास कितने लोन हैं (घर, गाड़ी, पर्सनल, एजुकेशन आदि मिलाकर)?",
    opta: "0",
    optaHindi: "0",
    optb: "1",
    optbHindi: "1",
    optc: "2-3",
    optcHindi: "2-3",
    optd: "3+",
    optdHindi: "3+",
    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 9,
    category: 1,
    que: "Which loan do you wish you didn’t have?",
    queHindi: "कौन सा लोन जो आपके पास नहीं होता तो अच्छा होता?",
    opta: "Personal Loan",
    optaHindi: "पर्सनल लोन",
    optb: "Car Loan",
    optbHindi: "कार लोन",
    optc: "Home Loan",
    optcHindi: "होम लोन",
    optd: "I don’t have any loans",
    optdHindi: "मेरे पास कोई लोन नहीं है",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 10,
    category: 1,
    que: "How many times, you felt that your income in not up to the mark, last 120 days ?",
    queHindi:
      "पिछले 120 दिनों में, कितनी बार आपको लगा कि आपकी आय कम है?",
    opta: "0 time",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 11,
    category: 1,
    que: "How many times, you felt that your expenses are more than your income, last 120 days ?",
    queHindi: "पिछले 120 दिनों में, कितनी बार आपको लगा कि आपके खर्चे ज्यादा हैं?",
    opta: "0 time",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "2+ times",
    optdHindi: "2+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 12,
    category: 1,
    que: "How many credit cards do you have?",
    queHindi: "आपके पास कितने क्रेडिट कार्ड हैं?",
    opta: "0",
    optaHindi: "0",
    optb: "1-2",
    optbHindi: "1-2",
    optc: "3-4",
    optcHindi: "3-4",
    optd: "4+",
    optdHindi: "4+",

    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 13,
    category: 2,
    que: "Office Workers: For how many Mondays were you excited for office to open out of 16 Mondays? Non-Office Workers: In the last 4 months, how many new things you learnt or did?",
    queHindi:"ऑफिस जाने वाले: पिछले 4 महीनों में 16 सोमवारों में से कितनी बार ऑफिस जाने का मन किया? ऑफिस नहीं जाने वाले: पिछले 4 महीनों  में आपने कितनी बार कुछ नया सीखा या किया?",
    opta: "0-4",
    optaHindi: "0-4",
    optb: "5-8",
    optbHindi: "5-8",
    optc: "9-12",
    optcHindi: "9-12",
    optd: "13+",
    optdHindi: "13+",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 14,
    category: 2,
    que: "In the last 4 months, for how many times, you cried while watching movie or serial or webseries or any emotional videos or while talking to someone?",
    queHindi:
      "पिछले 4 महीनों में, कितनी बार आप फिल्म, सीरियल, वीडियो देखते या किसी से बात करते हुए रोए?",
    opta: "0-2 times",
    optaHindi: "0-2 बार",
    optb: "3-5 times",
    optbHindi: "3-5 बार",
    optc: "6-9 times",
    optcHindi: "6-9 बार",
    optd: "10+ times",
    optdHindi: "10+ बार",
    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 15,
    category: 2,
    que: "In the last 4 months, for how many times, you gave a present including as small gift as even pat at back to someone without any occasion such as birthday, anniversary?",
    queHindi:
      "पिछले 4 महीनों में आपने कितनी बार बिना किसी खास मौके (जैसे जन्मदिन या सालगिरह) के किसी को छोटा सा तोहफ़ा या गले लगाकर खुशी दी?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "2+ times",
    optdHindi: "2+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 16,
    category: 2,
    que: "In the last 4 months, for how many times, you felt that you are loved?",
    queHindi:
      "पिछले 4 महीनों में, कितनी बार आपको लगा कि आपसे कोई प्यार करता है?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2-3 times",
    optcHindi: "2-3 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 17,
    category: 2,
    que: "In the last 4 months, for how many times, you felt that the super natural power is helping you silently?",
    queHindi:
      "पिछले 4 महीनों में, कितनी बार आपको लगा कि भगवान आपकी मदद कर रहे हैं?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2-3 times",
    optcHindi: "2-3 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 18,
    category: 2,
    que: "In the last 4 months, for how many times, you had breakfast, lunch, dinner on time?",
    queHindi:
      "पिछले 4 महीनों में, कितनी बार आपने समय पर नाश्ता, दोपहर का खाना, रात का खाना खाया?",
    opta: "0-30 times",
    optaHindi: "0-30 बार",
    optb: "31-60 times",
    optbHindi: "31-60 बार",
    optc: "61-90 times",
    optcHindi: "61-90 बार",
    optd: "91-120 times",
    optdHindi: "91-120 बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 19,
    category: 2,
    que: "How many times, you hugged your family members in last 120 days?",
    queHindi:
      "पिछले 120 दिनों में, आपने अपने परिवार के सदस्यों को कितनी बार गले लगाया?",
    opta: "0-30 times",
    optaHindi: "0-30 बार",
    optb: "31-60 times",
    optbHindi: "31-60 बार",
    optc: "61-90 times",
    optcHindi: "61-90 बार",
    optd: "91-120 times",
    optdHindi: "91-120 बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 20,
    category: 2,
    que: "How many times, you felt that your efforts are not recognised in last 120 days?",
    queHindi:
      "पिछले 120 दिनों में आपको कितनी बार लगा कि आपके काम को लोगों ने नजरअंदाज कर दिया?",
    opta: "0 time",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 21,
    category: 2,
    que: "How many times, you felt that your efforts are well recognised in last 120 days?",
    queHindi:
      "पिछले 120 दिनों में आपको कितनी बार लगा कि आपके काम की वैल्यू हुई?",
    opta: "0 time",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 22,
    category: 2,
    que: "How many times, you gave a treat or gift to yourself in last 120 days?",
    queHindi:
      "पिछले 120 दिनों में, आपने खुद को कितनी बार ट्रीट या उपहार दिया?",
    opta : "0 time",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question  
  },
  {
    id: 23,
    category: 2,
    que: "In the last 6 months, how many people have you encouraged, praised, or appreciated?",
    queHindi: "पिछले 6 महीनों में, आपने कितने लोगों की तारीफ की या हौसला बढ़ाया?",
    opta: "0",
    optaHindi: "0",
    optb: "1-2",
    optbHindi: "1-2",
    optc: "3-5",
    optcHindi: "3-5",
    optd: "5+",
    optdHindi: "5+",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 24,
    category: 2,
    que: "How many times, you felt that days went by too fast in last 120 days?",
    queHindi: "पिछले 120 दिनों में, आपने कितनी बार महसूस किया कि दिन बहुत जल्दी बीत गए?",
    opta: "0 time",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 25,
    category: 2,
    que: "How many times, you felt that days were passing too slow in last 120 days?",
    queHindi: "पिछले 120 दिनों में, आपने कितनी बार महसूस किया कि दिन बहुत धीरे बीत रहे हैं?",
    opta: "0 time",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",  
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 26,
    category: 3,
    que: "How many times have you laughed loudly with open heart in the last 4 months (120days)?",
    queHindi: "पिछले 4 महीनों में, आप कितनी बार दिल खोलकर हँसे?(जैसे स्कूल या कॉलेज में दोस्तों के साथ हँसते थे)",
    opta: "0-10 times",
    optaHindi: "0-10 बार",
    optb: "10+ times",
    optbHindi: "10+ बार",
    optc: "90+ times",
    optcHindi: "90+ बार",
    optd: "120+ times",
    optdHindi: "120+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 27,
    category: 3,
    que: "Physical activities (Any sport, game, gym, walk, yoga etc.) that you participated in the last 4 months (hours)?",
    queHindi: "पिछले 4 महीनों में आपने शारीरिक गतिविधियों (जैसे खेल, जिम, वॉक, योग आदि) में हिस्सा लिया और लगभग कितने घंटे दिए?",
    opta: "0-20 hours",
    optaHindi: "0-20 घंटे",
    optb: "21-90 hours",
    optbHindi: "21-90 घंटे",
    optc: "91-120 hours",
    optcHindi: "91-120 घंटे",
    optd: "120+ hours",
    optdHindi: "120+ घंटे",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 28,
    category: 3,
    que: "In the last 6-12 months, for how many times you stayed in a hotel to just rejuvenate?",
    queHindi: "पिछले 6-12 महीनों में, आप कितनी बार केवल मनोरंजन के लिए होटल में रुके?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question

  },
  {
    id: 29,
    category: 3,
    que:"In the last 4 months, for how many times, you missed to have breakfast?",
    queHindi: "पिछले 4 महीनों में, कितनी बार आप नाश्ता करना भूल गए?",
    opta: "0-30 times",
    optaHindi: "0-30 बार",
    optb: "31-60 times",
    optbHindi: "31-60 बार",
    optc: "61-90 times",
    optcHindi: "61-90 बार",
    optd: "91-120 times",
    optdHindi: "91-120 बार",
    reverseScoring: true, // Reverse scoring for this question
  },{
    id: 30,
    category: 3,
    que: "How many days you enjoyed eating food in last 120 days?",
    queHindi: "पिछले 120 दिनों में, कितने दिन आपने खाना खाने का आनंद लिया?",
    opta: "0-30 days",
    optaHindi: "0-30 दिन",
    optb: "31-60 days",
    optbHindi: "31-60 दिन",
    optc: "61-90 days",
    optcHindi: "61-90 दिन",
    optd: "91-120 days",
    optdHindi: "91-120 दिन",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 31,
    category: 3,
    que: "How many days of fasting, you did in last 120 days?",
    queHindi: "पिछले 120 दिनों में, आपने कितने दिन उपवास किया?",
    opta: "0",
    optaHindi: "0",
    optb: "1",
    optbHindi: "1",
    optc: "2-3",
    optcHindi: "2-3",
    optd: "4+",
    optdHindi: "4+",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 32,
    category: 3,
    que: "How many times, you gave a gift by yourself to someone in last 120 days? A gift can be as small as even a flower.",
    queHindi: "पिछले 120 दिनों में आपने किसी को अपनी तरफ़ से कितनी बार कोई उपहार दिया? उपहार छोटा सा फूल भी हो सकता है।",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 33,
    category: 3,
    que: "How many hrs, you gave yourself a sun exposure in last 120 days? Considering 120 days were sunny days :-)",
    queHindi: "पिछले 120 दिनों में आपने कितने घंटे खुले जगह में धूप लेते हुए बिताए? (माना कि 120 दिन धूप वाले थे)",
    opta: "0-30 hours",
    optaHindi: "0-30 घंटे",
    optb: "31-60 hours",
    optbHindi: "31-60 घंटे",
    optc: "61-90 hours",
    optcHindi: "61-90 घंटे",
    optd: "91-120 hours",
    optdHindi: "91-120 घंटे",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 34,
    category: 3,
    que: "How many times, you felt like losing your weight, last 120 days?",
    queHindi: "पिछले 120 दिनों में, आपने कितनी बार वजन कम करने का मन बनाया?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 35,
    category: 3,
    que: "How many times, you went for shopping for yourself, last 120 days?",
    queHindi: "पिछले 120 दिनों में, आपने अपने लिए कितनी बार शॉपिंग की?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 36,
    category: 4,
    que: "How many times have you listened(not just heard) to songs in the last 4 months (120days) for more than 15 minutes?",
    queHindi: "पिछले 4 महीनों में, आपने कम से कम 15 मिनट ध्यान से गाने कितनी बार सुने?",
    opta: "0-2 times",
    optaHindi: "0-2 बार",
    optb: "10+ times",
    optbHindi: "10+ बार",
    optc: "90+ times",
    optcHindi: "90+ बार",
    optd: "120+ times",
    optdHindi: "120+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 37,
    category: 4,
    que: "How many time have you sung or hummed at least one song in last 4 months (120days) even in bathroom?",
    queHindi: "पिछले 4 महीनों में, आपने कितनी बार मस्ती में गाने गाए या गुनगुनाए (नहाते समय भी गिनें)?",
    opta: "0-2 times",
    optaHindi: "0-2 बार",
    optb: "10+ times",
    optbHindi: "10+ बार",
    optc: "90+ times",
    optcHindi: "90+ बार",
    optd: "120+ times",
    optdHindi: "120+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 38,
    category: 4,
    que: "How many times have you danced in the last 4 months (120days) even in bathroom?",
    queHindi: "पिछले 4 महीने में, आपने कितनी बार मस्ती में नाचे?",
    opta: "0-2 times",
    optaHindi: "0-2 बार",
    optb: "3-10 times",
    optbHindi: "3-10 बार",
    optc: "11-45 times",
    optcHindi: "11-45 बार",
    optd: "45+ times",
    optdHindi: "45+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 39,
    category: 4,
    que: "In the last 6-12 months, for how many times you went out with family on vacation including overseas trip?",
    queHindi: "पिछले 6 से 12 महीनों में आप परिवार के साथ कितनी बार घूमने गए, जिसमें विदेश की यात्रा भी शामिल है?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 40,
    category: 4,
    que: "In the last 6-12 months, for how many times you went out on vacation?",
    queHindi: "पिछले ६-१२ महीनों में, आप कितनी बार छुट्टियों पर गए?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "2+ times",
    optdHindi: "2+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 41,
    category: 4,
    que: "In the last 4 months, for how many times you clapped approximately?",
    queHindi: "पिछले 6 महीनों में, आपने लगभग कितनी बार ताली बजाई?",
    opta: "0-2 times",
    optaHindi: "0-2 बार",
    optb: "2-10 times",
    optbHindi: "2-10 बार",
    optc: "10-20 times",
    optcHindi: "10-20 बार",
    optd: "20+ times",
    optdHindi: "20+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 42,
    category: 4,
    que: "In the last 6 months, for how many times you talked to your parents/siblings?",
    queHindi: "पिछले 6 महीनों में, आपने कितनी बार अपने माता-पिता/भाई-बहनों से बात की?",
    opta: "0-9 times",
    optaHindi: "0-9 बार",
    optb: "10+ times",
    optbHindi: "10+ बार",
    optc: "100+ times",
    optcHindi: "100+ बार",
    optd: "150+ times",
    optdHindi: "150+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 43,
    category: 4,
    que: "In the last 4 months, for how many months, you could not talk to your parents/siblings?",
    queHindi: "पिछले 4 महीनों में, कितने महीनों तक आप अपने माता-पिता/भाई-बहनों से बात नहीं कर पाए?",
    opta: "0 months",
    optaHindi: "0 महीने",
    optb: "1 month",
    optbHindi: "1 महीने",
    optc: "2 months",
    optcHindi: "2 महीने",
    optd: "2+ months",
    optdHindi: "2+ महीने",
    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 44,
    category: 4,
    que: "In the last 4 months, for how many weekends, you could enjoy or can call it satisfying weekend?",
    queHindi: "पिछले 4 महीनों में से आप कितने वीकेंड को आनंदभरा और संतोषजनक कह सकते हैं?",
    opta: "0-4",
    optaHindi: "0-4",
    optb: "5-8",
    optbHindi: "5-8",
    optc: "9-12",
    optcHindi: "9-12",
    optd: "13+",
    optdHindi: "13+",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 45,
    category: 4,
    que: "How many hrs, you spent watching a comedy movie/TV serial/standup in last 120 days?",
    queHindi: "पिछले 120 दिनों में, आपने कितने घंटे कॉमेडी फिल्म, सीरियल या स्टैंडअप देखा?",
    opta: "0-30 hours",
    optaHindi: "0-30 घंटे",
    optb: "31-60 hours",
    optbHindi: "31-60 घंटे",
    optc: "61-90 hours",
    optcHindi: "61-90 घंटे",
    optd: "91-120 hours",
    optdHindi: "91-120 घंटे",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 46,
    category: 4,
    que: "How many times, you got angry on anything in last 120 days?",
    queHindi: "पिछले 120 दिनों में, आप कितनी बार किसी बात पर गुस्सा हुए?",
    opta: "0-10 times",
    optaHindi: "0-10 बार",
    optb: "11-60 times",
    optbHindi: "11-60 बार",
    optc: "61-90 times",
    optcHindi: "61-90 बार",
    optd: "91-120 times",
    optdHindi: "91-120 बार",
    reverseScoring: true, // Reverse scoring for this question
  },
  {
    id: 47,
    category: 4,
    que: "How many times, you felt proud on yourself in last 120 days?",
    queHindi: "पिछले 120 दिनों में आपको अपने ऊपर कितनी बार गर्व महसूस हुआ?",
    opta: "0-30 days",
    optaHindi: "0-30 दिन",
    optb: "31-60 days",
    optbHindi: "31-60 दिन",
    optc: "61-90 days",
    optcHindi: "61-90 दिन",
    optd: "91-120 days",
    optdHindi: "91-120 दिन",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 48,
    category: 4,
    que: "How many times, you did what you love to do in last 120 days?",
    queHindi: "पिछले 120 दिनों में आपने कितनी बार वह काम किया जो आपको पसंद है?",
    opta: "0-30 days",
    optaHindi: "0-30 दिन",
    optb: "31-60 days",
    optbHindi: "31-60 दिन",
    optc: "61-90 days",
    optcHindi: "61-90 दिन",
    optd: "91-120 days",
    optdHindi: "91-120 दिन",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 49,
    category: 4,
    que: "How many days, it has been, when you enjoyed the nature (e.g. trees, river, mountain etc.) in last 120 days?",
    queHindi: "पिछले 120 दिनों में ऐसे कितने दिन थे जब आपने प्रकृति  नज़ारों (जैसे पेड़, नदी, पहाड़ आदि) का आनंद लिया?",
    opta: "0",
    optaHindi: "0",
    optb: "1 day",
    optbHindi: "1 दिन",
    optc: "2 days",
    optcHindi: "2 दिन",
    optd: "3+ days",
    optdHindi: "3+ दिन",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 50,
    category: 4,
    que: "How many times, you patted at your back in last 120 days?",
    queHindi: "पिछले 120 दिनों में, आपने खुद को कितनी बार पीठ थपथपाई?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 51,
    category: 4,
    que: "How many weekends, you thoroughly enjoyed in last 120 days? There are 16 weekend days (Saturday & Sunday) considering 4 months period",
    queHindi: "पिछले 120 दिनों में, आपने कितने वीकेंड्स (शनिवार और रविवार) का पूरा आनंद लिया? (कुल 16 वीकेंड्स)",
    opta: "0-4",
    optaHindi: "0-4",
    optb: "5-8",
    optbHindi: "5-8",
    optc: "9-12",
    optcHindi: "9-12",
    optd: "13+",
    optdHindi: "13+",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 52,
    category: 4,
    que: "How many times, you felt like learning a new musical instrument, in last 120 days?",
    queHindi: "पिछले 120 दिनों में आपको कितनी बार नया संगीत यंत्र सीखने का मन हुआ?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 53,
    category: 5,
    que: "In the last 4 months, for many days your sleep time was more than 7 hours?",
    queHindi: "पिछले 4 महीनों में, आप कितने दिन लगातार 7 घंटे या उससे ज्यादा सोए?",
    opta: "0-30 days",
    optaHindi: "0-30 दिन",
    optb: "31-60 days",
    optbHindi: "31-60 दिन",
    optc: "61-100 days",
    optcHindi: "61-100 दिन",
    optd: "100+ days",
    optdHindi: "100+ दिन",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 54,
    category: 6,
    que: "How many friends and relatives you openly talked to in the last 4 months (120days)?",
    queHindi: "पिछले 4 महीनों में, आपने अपने कितने दोस्तों या रिश्तेदारों से अच्छे से बात की?",
    opta: "0-2",
    optaHindi: "0-2",
    optb: "3-10",
    optbHindi: "3-10",
    optc: "11-20",
    optcHindi: "11-20",
    optd: "20+",
    optdHindi: "20+",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 55,
    category: 6,
    que: "How many new friends have you made in the last 4 months (120days)?",
    queHindi: "पिछले 4 महीनों में, आपने कितने नए दोस्त बनाए?",
    opta: "0",
    optaHindi: "0",
    optb: "1",
    optbHindi: "1",
    optc: "2",
    optcHindi: "2",
    optd: "3+",
    optdHindi: "3+",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 56,
    category: 6,
    que: "In the last 6-12 months, for how many times you attended any marriage ceremony?",
    queHindi: "पिछले 6-12 महीनों में, आप कितनी बार किसी शादी समारोह में शामिल हुए?",
    opta: "0",
    optaHindi: "0",
    optb: "1",
    optbHindi: "1",
    optc: "2",
    optcHindi: "2",
    optd: "3+",
    optdHindi: "3+",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 57,
    category: 6,
    que: "In the last 4 months, for how many times, you felt that you are blessed to be surrounded by good number positive people?",
    queHindi: "पिछले 4 महीनों में आपको कितनी बार लगा कि आप अच्छे और सकारात्मक लोगों के बीच रहकर सौभाग्यशाली हैं?",
    opta: "0",
    optaHindi: "0",
    optb: "1",
    optbHindi: "1",
    optc: "2-3",
    optcHindi: "2-3",
    optd: "3+",
    optdHindi: "3+",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 58,
    category: 6,
    que: "How many times, you hugged someone outside of your family in last 120 days?",
    queHindi: "पिछले 120 दिनों में, आपने अपने परिवार के बाहर किसी को कितनी बार गले लगाया?",
    opta: "0-30 times",
    optaHindi: "0-30 बार",
    optb: "31-60 times",
    optbHindi: "31-60 बार",
    optc: "61-90 times",
    optcHindi: "61-90 बार",
    optd: "91-120 times",
    optdHindi: "91-120 बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 59,
    category: 6,
    que: "How many times, you passed a smile to someone even unknown while walking by, last 120 days",
    queHindi: "पिछले 120 दिनों में आपने कितनी बार किसी को देखकर मुस्कान दी? (वो व्यक्ति अजनबी भी हो सकता है।)",
    opta: "0-30 times",
    optaHindi: "0-30 बार",
    optb: "31-60 times",
    optbHindi: "31-60 बार",
    optc: "61-90 times",
    optcHindi: "61-90 बार",
    optd: "91-120 times",
    optdHindi: "91-120 बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 60,
    category: 6,
    que: "How many times, a stranger including a baby, passed a smile to you while walking by, last 120 days",
    queHindi: "पिछले 120 दिनों में, चलते-फिरते किसी अनजान (शिशु सहित) ने आपको कितनी बार मुस्कान दी?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 61,
    category: 6,
    que: "How many times, you hosted a party, last 120 days?",
    queHindi: "पिछले 120 दिनों में, आपने कितनी बार पार्टी होस्ट की?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 62,
    category: 6,
    que: "How many times, you were invited for a party, last 120 days?",
    queHindi: "पिछले 120 दिनों में, आपको कितनी बार पार्टी के लिए बुलाया गया?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
  {
    id: 63,
    category: 6,
    que: "How many times, you went out for a party, last 120 days?",
    queHindi: "पिछले 120 दिनों में, आप कितनी बार पार्टी में गए?",
    opta: "0 times",
    optaHindi: "0 बार",
    optb: "1 time",
    optbHindi: "1 बार",
    optc: "2 times",
    optcHindi: "2 बार",
    optd: "3+ times",
    optdHindi: "3+ बार",
    reverseScoring: false, // Normal scoring for this question
  },
];

export const finalAns = [];
